import { render, staticRenderFns } from "./sw-login.vue?vue&type=template&id=0085d030&"
import script from "./sw-login.vue?vue&type=script&lang=ts&"
export * from "./sw-login.vue?vue&type=script&lang=ts&"
import style0 from "./sw-login.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports